<template>
  <div>
    <a-modal
      v-model="visible"
      title="Edit exam details"
      :width="1080"
      style="top: 20px"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
          >Update Exam Setup</a-button
        >
      </template>
      <a-spin :spinning="loading">
        <a-form :form="form">
          <div class="row mb-0">
            <!-- Select Session -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Session">
                <a-select
                  v-decorator="[
                    'session_id',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a session!!',
                        },
                      ],
                      initialValue: currentSession ? currentSession.id : '',
                    },
                  ]"
                  placeholder="Select session"
                  :disabled="true"
                >
                  <a-select-option
                    v-for="schoolSession in schoolSessions"
                    :value="schoolSession.id"
                    :key="schoolSession.id"
                  >
                    {{ schoolSession.name }}
                    <small class="text-primary ml-3">{{
                      currentSession.id === schoolSession.id ? "Current" : ""
                    }}</small>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <!-- Select Class -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Class">
                <a-spin :spinning="classSpinning">
                  <a-select
                    v-decorator="[
                      'class_id',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select a class!!',
                          },
                        ],
                        initialValue: undefined,
                      },
                    ]"
                    placeholder="Select class"
                    @change="handleClassSelect"
                    :disabled="true"
                  >
                    <a-select-option :value="undefined">
                      Select class
                    </a-select-option>
                    <template v-for="schoolClass in schoolClasses">
                      <a-select-option
                        :value="schoolClass.id"
                        :key="schoolClass.id"
                      >
                        {{ schoolClass.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <!-- Select Section -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Sections">
                <a-spin :spinning="sectionSpinning">
                  <a-checkbox-group :disabled="true"
                    v-decorator="[
                      'sections',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select a section!!',
                          },
                        ],
                        initialValue: [0],
                      },
                    ]"
                    @change="handleSectionAllSelect"
                  >
                    <a-checkbox
                      :value="0"
                      :disabled="!form.getFieldValue('class_id')"
                    >
                      All
                    </a-checkbox>
                    <template class="col-4" v-for="section in sections">
                      <a-checkbox
                        :value="section.id"
                        :key="section.id"
                        :disabled="isAllSections"
                      >
                        {{ section.name }}
                      </a-checkbox>
                    </template>
                  </a-checkbox-group>
                </a-spin>
              </a-form-item>
            </div>
            <!-- Select is grades enabled -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Enable grades">
                <a-radio-group :disabled="true"
                  v-decorator="[
                    'grades',
                    {
                      rules: [
                        { required: true, message: 'This value is required' },
                      ],
                      initialValue: 0,
                    },
                  ]"
                >
                  <a-radio :value="1">Yes</a-radio>
                  <a-radio :value="0">No</a-radio>
                </a-radio-group>
              </a-form-item>
            </div>
            <!-- Select Exam -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Select Exam">
                <a-select
                  v-decorator="[
                    'exam_id',
                    {
                      rules: [
                        { required: true, message: 'Please select an exam!!' },
                      ],
                    },
                  ]"
                  placeholder="Select Exam"
                >
                  <a-select-option
                    v-for="schoolExam in schoolExams"
                    :value="schoolExam.id"
                    :key="schoolExam.id"
                  >
                    {{ schoolExam.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <!-- Exam setting -->
            <div class="col-md-3 mb-2">
              <a-form-item label=" Select Exam Setting">
                <a-select
                  v-decorator="['exam_setting_id',
                  {
                     rules: [
                        { required: true, message: 'This value is required' },
                      ],
                  }]"
                  placeholder="Select Exam Setting"
                >
                  <a-select-option
                    v-for="Examsetting in examsettingdata"
                    :value="Examsetting.id"
                    :key="Examsetting.id"
                  >
                    {{ Examsetting.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <!-- Declare_all_section -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Declare All Section">
                <a-radio-group :disabled="true"
                  v-decorator="[
                    'declare_all_section',
                    {
                      rules: [
                        { required: true, message: 'This value is required' },
                      ],
                      initialValue: 0,
                    },
                  ]"
                >
                  <a-radio :value="1">Yes</a-radio>
                  <a-radio :value="0">No</a-radio>
                </a-radio-group>
              </a-form-item>
            </div>

            <div class="col-md-12" v-if="classSubjects.length > 0">
              <a-divider />
              <p class="font-weight-bold mt-3">Setup Exam Subjects</p>
              <a-spin :spinning="sectionSpinning">
                <div class="table-responsive">
                  <table class="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Subject</th>
                        <th>Full Mark</th>
                        <th>Pass Mark</th>
                        <th>Exam Date</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Grades only</th>
                        <th>Oral</th>
                        <th>No exam</th>
                        <th>In total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="subject in classSubjects" :key="subject.id">
                        <th
                          style="
                            min-width: 30px;
                            vertical-align: middle;
                            padding: 0.5rem;
                          "
                          class="text-center"
                        >
                          <a-form-item>
                            <a-checkbox
                              v-decorator="[
                                `subjects[${subject.subject_id}][selected]`,
                                {
                                  valuePropName: 'checked',
                                  initialValue: false,
                                },
                              ]"
                              @change="
                                toggleSubjectSelect($event, subject.subject_id)
                              "
                            >
                            </a-checkbox>
                          </a-form-item>
                        </th>
                        <td
                          style="
                            min-width: 150px;
                            vertical-align: middle;
                            padding: 0.5rem;
                          "
                        >
                          {{ subject.subject.name }}
                          <a-form-item class="d-none">
                            <a-input
                              v-decorator="[
                                `subjects[${subject.subject_id}][subject_id]`,
                                {
                                  rules: [
                                    { required: true, message: 'Required' },
                                  ],
                                  initialValue: subject.subject_id,
                                },
                              ]"
                            />
                          </a-form-item>
                        </td>
                        <td style="min-width: 80px">
                          <a-form-item>
                            <a-input
                              placeholder=""
                              v-decorator="[
                                `subjects[${subject.subject_id}][full_mark]`,

                              ]"

                              :disabled="
                                !form.getFieldValue(
                                  `subjects[${subject.subject_id}][selected]`
                                )
                              "
                              style="width: 100%"
                            />
                          </a-form-item>
                        </td>
                        <td style="min-width: 80px">
                          <a-form-item>
                            <a-input
                              placeholder=""
                              v-decorator="[
                                `subjects[${subject.subject_id}][pass_mark]`,
                              ]"

                              :disabled="
                                !form.getFieldValue(
                                  `subjects[${subject.subject_id}][selected]`
                                )
                              "
                              style="width: 100%"
                            />
                          </a-form-item>
                        </td>
                        <td style="min-width: 130px">
                          <a-form-item>
                            <a-date-picker
                              :disabledDate="disabledDate"
                              v-decorator="[
                                `subjects[${subject.subject_id}][date]`,
                                {
                                  rules: [
                                    {
                                      required: form.getFieldValue(
                                        `subjects[${subject.subject_id}][selected]`
                                      ),
                                      message: 'Please input a start date',
                                    },
                                  ],
                                },
                              ]"
                              :format="dateFormat"
                              :disabled="
                                !form.getFieldValue(
                                  `subjects[${subject.subject_id}][selected]`
                                )
                              "
                              style="width: 100%"
                            />
                          </a-form-item>
                        </td>
                        <td style="min-width: 130px">
                          <a-form-item>
                            <a-time-picker
                              v-decorator="[
                                `subjects[${subject.subject_id}][start_time]`,
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input an start time',
                                    },
                                  ],
                                },
                              ]"
                              use12Hours
                              :format="timeFormat"
                              :disabled="
                                !form.getFieldValue(
                                  `subjects[${subject.subject_id}][selected]`
                                )
                              "
                              style="width: 100%"
                            >
                            </a-time-picker>
                          </a-form-item>
                        </td>
                        <td style="min-width: 130px">
                          <a-form-item>
                            <a-time-picker
                              v-decorator="[
                                `subjects[${subject.subject_id}][end_time]`,
                                {
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input an end time',
                                    },
                                  ],
                                },
                              ]"
                              use12Hours
                              :format="timeFormat"
                              :disabled="
                                !form.getFieldValue(
                                  `subjects[${subject.subject_id}][selected]`
                                )
                              "
                              style="width: 100%"
                            >
                            </a-time-picker>
                          </a-form-item>
                        </td>
                        <td style="min-width: 50px" class="text-center">
                          <a-form-item>
                            <a-checkbox
                              v-decorator="[
                                `subjects[${subject.subject_id}][grades_only]`,
                                {
                                  valuePropName: 'checked',
                                  initialValue: false,
                                },
                              ]"
                                :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) ||
                              form.getFieldValue(
                                `subjects[${subject.subject_id}][is_in_total]`
                              )
                            "
                            >
                            </a-checkbox>
                          </a-form-item>
                        </td>
                        <td style="min-width: 50px" class="text-center">
                          <a-form-item>
                            <a-checkbox
                              v-decorator="[
                                `subjects[${subject.subject_id}][is_oral]`,
                                {
                                  valuePropName: 'checked',
                                  initialValue: false,
                                },
                              ]"
                              :disabled="
                                !form.getFieldValue(
                                  `subjects[${subject.subject_id}][selected]`
                                )
                              "
                            >
                            </a-checkbox>
                          </a-form-item>
                        </td>
                        <td style="min-width: 50px" class="text-center">
                          <a-form-item>
                            <a-checkbox
                              v-decorator="[
                                `subjects[${subject.subject_id}][has_exam]`,
                                {
                                  valuePropName: 'checked',
                                  initialValue: false,
                                },
                              ]"
                              :disabled="
                                !form.getFieldValue(
                                  `subjects[${subject.subject_id}][selected]`
                                )
                              "
                            >
                            </a-checkbox>
                          </a-form-item>
                        </td>
                        <td style="min-width: 50px" class="text-center">
                          <a-form-item>
                            <a-checkbox
                              v-decorator="[
                                `subjects[${subject.subject_id}][is_in_total]`,
                                {
                                  valuePropName: 'checked',
                                  initialValue: false,
                                },
                              ]"
                              :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) ||
                              form.getFieldValue(
                                `subjects[${subject.subject_id}][grades_only]`
                              )
                            "
                            >
                            </a-checkbox>
                          </a-form-item>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </a-spin>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'
import moment from 'moment'

import {
  makeClassSectionExamData,
  makeClassSectionExamSubjectData,
} from './fields'

export default {
  name: 'EditExamSetup',
  mounted: function () {
    this.getExams()
    this.getExamsSetting()
    this.$http
      .get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id

        this.getClasses()
      })
      .catch((error) => {
        console.log(error)
        this.$neoNotify.error(error)
      })
    this.$eventBus.$on('openExamSetupEditModal', this.showModal)
  },
  computed: {
    currentSession: function () {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
    isAllSections: function (val) {
      if (val) {
        this.form.setFieldsValue({ sections: [0] })
      }
    },
    classSubjects: function (val) {
      if (val.length > 0) {
        this.$nextTick(() => {
          const subjectFieldsData = makeClassSectionExamSubjectData(
            this.classSectionExamData.class_section_exam_subject
          )
          this.form.setFieldsValue(subjectFieldsData)
        })
      }
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      examLoading: false,
      schoolExams: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      classSubjects: [],
      classSectionExamId: null,
      classSectionExamData: null,
      selectedSession: undefined,
      isAllSections: true,
      classSpinning: false,
      sectionSpinning: false,
      subjectSpinning: false,
      dateFormat: 'DD-MM-YYYY',
      timeFormat: 'hh:mm a',
      examsettingdata: null,
    }
  },
  methods: {
    moment,
    showModal(classSectionExamId) {
      this.classSectionExamId = classSectionExamId
      this.visible = true
      this.loading = true
      this.$http
        .get(`/api/classsectionexam/${classSectionExamId}`)
        .then(({ data }) => {
          // console.log("first : ",data.data)
          this.classSectionExamData = data.data
          this.isAllSections = data.data.is_all_section === 1
          this.getClassSections(data.data.class_id)
          this.getClassSubjects(data.data.class_id)

          const fieldsData = makeClassSectionExamData(data.data)
          this.form.setFieldsValue(fieldsData)

          this.loading = false
        })
        .catch((error) => {
          console.log(error)
          this.$neoNotify.error(error)
        })
    },
    getExams() {
      this.examLoading = true
      this.$http
        .get('/api/exam', {
          params: {
            limit: 15,
          },
        })
        .then(({ data }) => {
          this.examLoading = false
          this.schoolExams = data.data
        })
    },
    getExamsSetting: function () {
      // this.classSpinning = true;
      this.$http
        .get('/api/exam/settings/all', {
          session_id: this.selectedSession,
        })
        .then(({ data }) => {
          this.examsettingdata = data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getClassSubjects(classId, subjectData) {
      this.$http
        .get(`/api/subject/class/${classId}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.classSubjects = data.data.all
          // if (subjectData) {
          //   let subjectFieldsData = makeClassSectionExamSubjectData(subjectData)
          //   console.log(subjectFieldsData)
          //   this.form.setFieldsValue(subjectFieldsData)
          // }
          this.subjectSpinning = false
        })
        .catch((error) => {
          console.log(error)
          this.$neoNotify.error(error)
        })
    },
    getClasses: function () {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch((error) => {
          console.log(error)
          this.$neoNotify.error(error)
        })
    },
    handleClassSelect(value) {
      this.form.resetFields(['sections'])
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
        this.getClassSubjects(value)
      }
    },
    getClassSections(value) {
      this.$http
        .get(`/api/section/class/${value}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch((error) => {
          console.log(error)
          this.$neoNotify.error(error)
        })
    },
    handleSectionAllSelect(value) {
      if (value.includes(0)) {
        this.isAllSections = true
      } else {
        this.isAllSections = false
      }
    },
    toggleSubjectSelect(e, subjectId) {
      if (!e.target.checked) {
        this.form.resetFields([
          `subjects[${subjectId}][full_mark]`,
          `subjects[${subjectId}][pass_mark]`,
          `subjects[${subjectId}][date]`,
          `subjects[${subjectId}][start_time]`,
          `subjects[${subjectId}][end_time]`,
          `subjects[${subjectId}][grades_only]`,
          `subjects[${subjectId}][is_oral]`,
          `subjects[${subjectId}][has_exam]`,
          `subjects[${subjectId}][is_in_total]`,
        ])
      }
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add update class exam!`,
            onOk: () => {
              const formData = this.makeFormData(values)
              // console.log(formData)
              this.$http
                .patch(
                  `/api/classsectionexam/${this.classSectionExamId}`, {
                    class_id: formData.class_id,
                    declare_all_section: formData.declare_all_section,
                    exam_id: formData.exam_id,
                    exam_setting_id: formData.exam_setting_id,
                    grades: formData.grades,
                    is_all_section: formData.is_all_section,
                    sections: formData.sections,
                    session_id: formData.session_id,
                    subjects: formData.subjects,
                  }
                  // formData

                )
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Setup successful updated!',
                    description: `Exam has been successfully updated!`,
                  })
                  this.form.resetFields()
                  this.classSubjects = []
                  this.sections = []
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.classSubjects = []
      this.sections = []
      this.visible = false
    },
    disabledDate(current) {
      // Can not select days before today
      return current < moment().startOf('day')
    },
    makeFormData(values) {
      const subjects = values.subjects
        .filter((element) => {
          return element.selected
        })
        .map((element) => {
          delete element['selected']

          element.date = moment(element.date).format('YYYY-MM-DD')

          element.start_time = element.start_time
            ? moment(element.start_time).format('HH:mm:ss')
            : undefined
          element.end_time = element.end_time
            ? moment(element.end_time).format('HH:mm:ss')
            : undefined

          element.grades_only = element.grades_only ? 1 : 0
          element.is_oral = element.is_oral ? 1 : 0
          element.has_exam = element.has_exam ? 0 : 1
          element.is_in_total = element.is_in_total ? 1 : 0

          return element
        })

      values.is_all_section = 0

      if (values.sections.includes(0)) {
        values.sections = this.sections.map((element) => {
          return element.id
        })
        values.is_all_section = 1
      }

      values.subjects = subjects
      return values
    },
  },
}
</script>
